import { render, staticRenderFns } from "./PrimaryItem.vue?vue&type=template&id=56121c7c&"
import script from "./PrimaryItem.vue?vue&type=script&lang=js&"
export * from "./PrimaryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports